import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-configs-form',
  templateUrl: './configs-form.component.html'
})

export class ConfigsFormComponent implements OnInit {

  url: string = 'configs';
  id!: string;
  form!: FormGroup;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {

      this.id = params['id'];

      if (this.id) {
        this.getData();
      }
    });

    this.form = this.fb.group({
      type: ['admin',],
      name: ['', [Validators.required]],
      code: ['', [Validators.required]],
      value: ['', [Validators.required]],
      status: [''],
    });
  }

  isFieldInvalid(field: string) {
    return (
      (this.form.get(field)?.invalid && (this.form.get(field)?.dirty || this.form.get(field)?.touched))
    );
  }

  onSubmit(): void {
    if (this.id) {
        this.updateData();
    } else {
        this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe(response => {

      this.form.patchValue({
        name: response.name,
        code: response.code,
        value: response.value,
        status: response.status,
      });

    });
  }

  createData(): void {
    this.dataService.postData(`${this.url}/add`, this.form.value).subscribe(response => {

      if (response.rst) {
        this.messageService.add(response.msg, 'info');
        this.form.reset();
        this.router.navigateByUrl('administracion/configs');
      } else {
        this.messageService.add(response.msg, 'secondary');
      }

    });
  }

  updateData(): void {
    this.dataService.putData(`${this.url}/edit/${this.id}`, this.form.value).subscribe(response => {

      if (response.rst) {
        this.messageService.add(response.msg, 'info');
        this.form.reset();
        this.router.navigateByUrl('administracion/configs');
      } else {
        this.messageService.add(response.msg, 'secondary');
      }

    });
  }
}
